import { useTranslation } from 'react-i18next';
import { FieldArray } from 'formik';

import { Form, ResetFormHandler, TextField } from 'theSource/components';
import { GroupsFormSection, PhoneNumbersFormSection } from './components';
import { AddEditContactFormValues } from './types';
import { getValidationSchema } from './utils';

export interface ContactAddEditFormProps {
  isLoading: boolean;
  initialValues: AddEditContactFormValues;
  onCancel: () => void;
  onSubmit: (
    values: AddEditContactFormValues,
    resetForm: ResetFormHandler
  ) => void;
}

export const AddEditContactForm = ({
  isLoading,
  initialValues,
  onCancel,
  onSubmit,
}: ContactAddEditFormProps) => {
  const { t } = useTranslation('pages.contacts');

  return (
    <Form<AddEditContactFormValues>
      isLoading={isLoading}
      validationSchema={getValidationSchema()}
      initialValues={initialValues}
      onSubmitClick={onSubmit}
      onCancelClick={onCancel}
      testId="add-edit-contact-form"
      childrenStackSpacing={4}
    >
      <TextField required label={t('name')} name="name" id="name" />
      <TextField label={t('title')} name="title" id="title" />
      <TextField label={t('email')} name="email" id="email" />
      <FieldArray
        name="phones"
        render={(arrayHelpers) => (
          <PhoneNumbersFormSection arrayHelpers={arrayHelpers} />
        )}
      />
      <FieldArray
        name="groups"
        render={(arrayHelpers) => (
          <GroupsFormSection arrayHelpers={arrayHelpers} />
        )}
      />
      <TextField label={t('address')} name="address" id="address" />
      <TextField label={t('website')} name="website" id="website" />
      <TextField label={t('notes')} name="notes" id="notes" />
    </Form>
  );
};
